import createDebug from "debug";
import { computed } from "vue";
import { toRef, type MaybeRefOrGetter } from "vue";
import { getMenus } from "../menus";
import { useRoute } from "vue-router";

const debug = createDebug("useMenu");

export function useMenu(params: { region: MaybeRefOrGetter<string> }) {
  const region = toRef(params.region);
  const route = useRoute();

  debug("route is changed", route);
  const menus = computed(() => getMenus(region.value));

  return { menus };
}
